<template>
    <li
        class="slds-dropdown__item"
        role="presentation"
        v-on="$listeners"
    >
        <a
            role="menuitem"
            tabindex="0"
        >
            <span
                :title="label"
                class="slds-truncate"
            >
                <slot>{{ decodeHtml(label) }}</slot>
            </span>
        </a>
    </li>
</template>

<script>
    import decodeHtml from '../mixins/decode-html';

    export default {
        name: 'MAActionMenuitem',
        mixins: [decodeHtml],
        props: {
            label: {
                type: String,
                required: true
            }
        }
    };
</script>
